import { render, staticRenderFns } from "./fdInventory18.vue?vue&type=template&id=bb73f04e"
import script from "./fdInventory18.vue?vue&type=script&lang=js"
export * from "./fdInventory18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports